const FRIENDLY_FALLBACK =
  "Something went wrong. Please try again later.";

const INTERNAL_PATTERNS = [
  /migration/i,
  /database/i,
  /typeorm/i,
  /query failed/i,
  /internal server/i,
  /econn/i,
  /postgres/i,
  /relation ["/']/i,
  /column ["/']/i,
  /stack/i,
  /syntax error/i,
  /unexpected token/i,
  /failed to fetch/i,
  /networkerror/i,
  /cors/i,
  /503/i,
  /500/i,
];

export function toUserFacingError(
  error: unknown,
  fallback = FRIENDLY_FALLBACK
): string {
  const raw =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "";

  if (!raw || !raw.trim()) {
    return fallback;
  }

  if (INTERNAL_PATTERNS.some((pattern) => pattern.test(raw))) {
    return fallback;
  }

  if (raw.length > 180) {
    return fallback;
  }

  return raw;
}
